import { render, staticRenderFns } from "./AppErrlog.vue?vue&type=template&id=52801450&scoped=true&"
import script from "./AppErrlog.vue?vue&type=script&lang=js&"
export * from "./AppErrlog.vue?vue&type=script&lang=js&"
import style0 from "./AppErrlog.vue?vue&type=style&index=0&id=52801450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52801450",
  null
  
)

export default component.exports